import { render } from "./QuickView.vue?vue&type=template&id=6a30040f&scoped=true"
import script from "./QuickView.vue?vue&type=script&lang=js"
export * from "./QuickView.vue?vue&type=script&lang=js"

import "./QuickView.vue?vue&type=style&index=0&id=6a30040f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a30040f"]])

export default __exports__